<template>
  <transition name="slide-fade">
    <div v-if="value" class="layout-info-content-window-tabby abs">
      <div class="abs" @click="close"></div>
      <div class="window">
        <div class="header">
          <div class="small-title" v-html="title"></div>
          <div class="close" @click="close">
            <img src="@/assets/icons/close.svg" alt="close" />
          </div>
        </div>
        <div class="content">

          <div class="content-wrapper">
            <vuescroll :ops="ops">
              <div class="content-window">

                <div class="styles__body--a3828" style="padding: 13px; align-items: stretch;">
                  <div class="styles__header--8f936">
                    <svg viewBox="0 0 100 40" class="styles__tabby-info__logo--ec151 styles__logo--9b931" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M92.2524 0H7.74757C3.46871 0 0 3.48347 0 7.78054V32.2195C0 36.5165 3.46871 40 7.74757 40H92.2524C96.5313 40 100 36.5165 100 32.2195V7.78054C100 3.48347 96.5313 0 92.2524 0Z" fill="url(#paint0_linear_99_113_0.02455711980765063)"></path>
                      <path d="M86.9113 12.6893L81.5394 33.1972L81.5274 33.2434H85.7106L91.1016 12.6893H86.9113Z" fill="#292929"></path>
                      <path d="M20.4447 24.3575C19.817 24.6651 19.1268 24.8233 18.4279 24.8198C16.9206 24.8198 16.0655 24.5796 15.9731 23.3607V23.2793C15.9731 23.2301 15.967 23.1788 15.967 23.1306V19.5946L15.9731 19.1765V16.6805H15.967V15.6073L15.9731 15.1863V12.7746L12.237 13.269C14.7673 12.7787 16.2173 10.778 16.2173 8.7864V7.56049H12.015V13.3032L11.7778 13.3695V24.0018C11.9165 26.9892 13.888 28.7648 17.1146 28.7648C18.2708 28.762 19.4146 28.5251 20.4768 28.0684L20.4979 28.0594V24.3294L20.4447 24.3575Z" fill="#292929"></path>
                      <path d="M21.1069 11.9165L9.32401 13.7332V16.7216L21.1069 14.9049V11.9165Z" fill="#292929"></path>
                      <path d="M21.1069 16.2876L9.32401 18.1044V20.9582L21.1069 19.1424V16.2876Z" fill="#292929"></path>
                      <path d="M34.3287 17.6622C34.1619 14.3462 32.0878 12.3767 28.7075 12.3767C26.7652 12.3767 25.1634 13.1273 24.0762 14.5481C22.9889 15.969 22.4202 18.046 22.4202 20.5702C22.4202 23.0944 22.993 25.1784 24.0762 26.5993C25.1594 28.0201 26.7652 28.7698 28.7075 28.7698C32.0878 28.7698 34.1619 26.7932 34.3287 23.4561V28.4573H38.5269V12.7264L34.3287 13.3735V17.6622ZM34.5467 20.5702C34.5467 23.5104 33.0033 25.4095 30.6147 25.4095C28.1519 25.4095 26.6818 23.6008 26.6818 20.5702C26.6818 17.5215 28.1519 15.7007 30.6147 15.7007C31.8125 15.7007 32.8133 16.167 33.5077 17.0502C34.188 17.9134 34.5467 19.1313 34.5467 20.5702Z" fill="#292929"></path>
                      <path d="M50.773 12.3767C47.3917 12.3767 45.3177 14.3452 45.1529 17.6673V8.14732L40.9536 8.79545V28.4523H45.1529V23.4451C45.3177 26.7863 47.3917 28.7648 50.773 28.7648C54.7301 28.7648 57.0925 25.702 57.0925 20.5703C57.0925 15.4385 54.7301 12.3767 50.773 12.3767ZM48.8638 25.4096C46.4743 25.4096 44.9308 23.5105 44.9308 20.5703C44.9308 19.1313 45.2905 17.9134 45.9708 17.0533C46.6652 16.17 47.666 15.7038 48.8638 15.7038C51.3267 15.7038 52.7968 17.5246 52.7968 20.5733C52.7998 23.6009 51.3297 25.4096 48.8668 25.4096H48.8638Z" fill="#292929"></path>
                      <path d="M68.5306 12.3767C65.1493 12.3767 63.0743 14.3452 62.9095 17.6673V8.14732L58.7113 8.79545V28.4523H62.9035V23.4451C63.0683 26.7863 65.1433 28.7648 68.5246 28.7648C72.4807 28.7648 74.8431 25.702 74.8431 20.5703C74.8431 15.4385 72.4817 12.3767 68.5306 12.3767ZM66.6214 25.4096C64.2319 25.4096 62.6885 23.5105 62.6885 20.5703C62.6885 19.1313 63.0472 17.9134 63.7275 17.0533C64.4228 16.17 65.4237 15.7038 66.6214 15.7038C69.0833 15.7038 70.5534 17.5246 70.5534 20.5733C70.5514 23.6009 69.0813 25.4096 66.6214 25.4096Z" fill="#292929"></path>
                      <path d="M74.8531 12.6893H79.3368L82.9794 28.4232H78.96L74.8531 12.6893Z" fill="#292929"></path>
                      <defs><linearGradient id="paint0_linear_99_113_0.02455711980765063" x1="0" y1="19.9995" x2="100" y2="19.9995" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#3BFF9D"></stop><stop offset="1" stop-color="#3BFFC8"></stop></linearGradient>
                      </defs></svg>
                  </div>
                  <div class="styles__title--8f3d0" style="margin-top: 24px;">
                    <h3 class="styles__text--bfbd9" style="color: rgb(41, 41, 41);">
                      <span>Split in 4 interest-free payments of {{ formatPriceKlarna(total) }} {{ this.$store.state.langs.CURRENCY_SING }}.</span>
                    </h3>
                    <div class="styles__help--4dd86" style="color: rgb(41, 41, 41);">Get what you love, split the cost. No fees.</div>
                  </div>
                  <span style="margin-top: 32px;">
                    <div class="styles__tabby-promo__graph-with-titles--8fb98">
                      <div class="styles__tabby-promo__graph--d0747">
                        <div class="styles__tabby-promo__graph__ellipse--4e44a styles__tabby-promo__graph__ellipse_active--e6983 styles__tabby-promo__graph__ellipse_dark--a9aa7 styles__tabby-promo__graph__ellipse_big--be9f4">
                          <div class="styles__tabby-promo__graph__ellipse-section-1--071c6 styles__tabby-promo__graph__ellipse-section-1_dark--16948"></div>
                        </div>
                        <div class="styles__tabby-promo__graph__ellipse-divider--aeeeb styles__tabby-promo__graph__ellipse-divider_active--16b83 styles__tabby-promo__graph__ellipse-divider_dark--82538 styles__tabby-promo__graph__ellipse-divider_big--770af"></div>
                        <div class="styles__tabby-promo__graph__ellipse--4e44a styles__tabby-promo__graph__ellipse_dark--a9aa7 styles__tabby-promo__graph__ellipse_big--be9f4">
                          <div class="styles__tabby-promo__graph__ellipse-section-2--95d79 styles__tabby-promo__graph__ellipse-section-2_dark--8e8eb"></div>
                        </div>
                        <div class="styles__tabby-promo__graph__ellipse-divider--aeeeb styles__tabby-promo__graph__ellipse-divider_dark--82538 styles__tabby-promo__graph__ellipse-divider_big--770af"></div>
                        <div class="styles__tabby-promo__graph__ellipse--4e44a styles__tabby-promo__graph__ellipse_dark--a9aa7 styles__tabby-promo__graph__ellipse_big--be9f4">
                          <div class="styles__tabby-promo__graph__ellipse-section-3--a0593 styles__tabby-promo__graph__ellipse-section-3_dark--3ac3f"></div>
                        </div>
                        <div class="styles__tabby-promo__graph__ellipse-divider--aeeeb styles__tabby-promo__graph__ellipse-divider_dark--82538 styles__tabby-promo__graph__ellipse-divider_big--770af"></div>
                        <div class="styles__tabby-promo__graph__ellipse--4e44a styles__tabby-promo__graph__ellipse_dark--a9aa7 styles__tabby-promo__graph__ellipse_big--be9f4">
                          <div class="styles__tabby-promo__graph__ellipse-section-4--f2562 styles__tabby-promo__graph__ellipse-section-4_dark--b269d"></div>
                        </div>
                      </div>
                      <div class="styles__tabby-promo__graph-with-titles__descr--7eb00">
                        <div class="styles__tabby-promo__graph-with-titles__item-text--fe3b7 styles__tabby-promo__graph-with-titles__item-text_big--b9467">
                          <div>{{ formatPriceKlarna(total) }} {{ this.$store.state.langs.CURRENCY_SING }}</div>
                          <div>Today</div>
                        </div>
                        <div class="styles__tabby-promo__graph-with-titles__item-text--fe3b7 styles__tabby-promo__graph-with-titles__item-text_big--b9467">
                          <div>{{ formatPriceKlarna(total) }} {{ this.$store.state.langs.CURRENCY_SING }}</div>
                          <div>In 1 month</div>
                        </div>
                        <div class="styles__tabby-promo__graph-with-titles__item-text--fe3b7 styles__tabby-promo__graph-with-titles__item-text_big--b9467">
                          <div>{{ formatPriceKlarna(total) }} {{ this.$store.state.langs.CURRENCY_SING }}</div>
                          <div>In 2 months</div>
                        </div>
                        <div class="styles__tabby-promo__graph-with-titles__item-text--fe3b7 styles__tabby-promo__graph-with-titles__item-text_big--b9467">
                          <div>{{ formatPriceKlarna(total) }} {{ this.$store.state.langs.CURRENCY_SING }}</div>
                          <div>In 3 months</div>
                        </div>
                      </div>
                    </div>
                  </span>
                  <div class="styles__how-it-work-info--333f4" style="margin-top: 24px;">
                    <div class="styles__title--c59a5" style="color: rgb(41, 41, 41);">How it works:</div>
                    <ul class="styles__list--21e59">
                      <li class="styles__item--28e38" style="color: rgb(84, 84, 92);">
                        <div class="styles__item-number--10e7c styles__item-number_bold--abad4" style="color: rgb(41, 41, 41);">1</div>
                        <div class="styles__item-text--5063b styles__item-text_flex--4f618">Choose <svg viewBox="0 0 100 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="styles__tabby-info__logo--ec151 styles__logo--0ef56">
                          <path d="M92.2524 0H7.74757C3.46871 0 0 3.48347 0 7.78054V32.2195C0 36.5165 3.46871 40 7.74757 40H92.2524C96.5313 40 100 36.5165 100 32.2195V7.78054C100 3.48347 96.5313 0 92.2524 0Z" fill="url(#paint0_linear_99_113_0.06742761728975522)"></path>
                          <path d="M86.9113 12.6893L81.5394 33.1972L81.5274 33.2434H85.7106L91.1016 12.6893H86.9113Z" fill="#292929"></path>
                          <path d="M20.4447 24.3575C19.817 24.6651 19.1268 24.8233 18.4279 24.8198C16.9206 24.8198 16.0655 24.5796 15.9731 23.3607V23.2793C15.9731 23.2301 15.967 23.1788 15.967 23.1306V19.5946L15.9731 19.1765V16.6805H15.967V15.6073L15.9731 15.1863V12.7746L12.237 13.269C14.7673 12.7787 16.2173 10.778 16.2173 8.7864V7.56049H12.015V13.3032L11.7778 13.3695V24.0018C11.9165 26.9892 13.888 28.7648 17.1146 28.7648C18.2708 28.762 19.4146 28.5251 20.4768 28.0684L20.4979 28.0594V24.3294L20.4447 24.3575Z" fill="#292929"></path>
                          <path d="M21.1069 11.9165L9.32401 13.7332V16.7216L21.1069 14.9049V11.9165Z" fill="#292929"></path>
                          <path d="M21.1069 16.2876L9.32401 18.1044V20.9582L21.1069 19.1424V16.2876Z" fill="#292929"></path>
                          <path d="M34.3287 17.6622C34.1619 14.3462 32.0878 12.3767 28.7075 12.3767C26.7652 12.3767 25.1634 13.1273 24.0762 14.5481C22.9889 15.969 22.4202 18.046 22.4202 20.5702C22.4202 23.0944 22.993 25.1784 24.0762 26.5993C25.1594 28.0201 26.7652 28.7698 28.7075 28.7698C32.0878 28.7698 34.1619 26.7932 34.3287 23.4561V28.4573H38.5269V12.7264L34.3287 13.3735V17.6622ZM34.5467 20.5702C34.5467 23.5104 33.0033 25.4095 30.6147 25.4095C28.1519 25.4095 26.6818 23.6008 26.6818 20.5702C26.6818 17.5215 28.1519 15.7007 30.6147 15.7007C31.8125 15.7007 32.8133 16.167 33.5077 17.0502C34.188 17.9134 34.5467 19.1313 34.5467 20.5702Z" fill="#292929"></path>
                          <path d="M50.773 12.3767C47.3917 12.3767 45.3177 14.3452 45.1529 17.6673V8.14732L40.9536 8.79545V28.4523H45.1529V23.4451C45.3177 26.7863 47.3917 28.7648 50.773 28.7648C54.7301 28.7648 57.0925 25.702 57.0925 20.5703C57.0925 15.4385 54.7301 12.3767 50.773 12.3767ZM48.8638 25.4096C46.4743 25.4096 44.9308 23.5105 44.9308 20.5703C44.9308 19.1313 45.2905 17.9134 45.9708 17.0533C46.6652 16.17 47.666 15.7038 48.8638 15.7038C51.3267 15.7038 52.7968 17.5246 52.7968 20.5733C52.7998 23.6009 51.3297 25.4096 48.8668 25.4096H48.8638Z" fill="#292929"></path>
                          <path d="M68.5306 12.3767C65.1493 12.3767 63.0743 14.3452 62.9095 17.6673V8.14732L58.7113 8.79545V28.4523H62.9035V23.4451C63.0683 26.7863 65.1433 28.7648 68.5246 28.7648C72.4807 28.7648 74.8431 25.702 74.8431 20.5703C74.8431 15.4385 72.4817 12.3767 68.5306 12.3767ZM66.6214 25.4096C64.2319 25.4096 62.6885 23.5105 62.6885 20.5703C62.6885 19.1313 63.0472 17.9134 63.7275 17.0533C64.4228 16.17 65.4237 15.7038 66.6214 15.7038C69.0833 15.7038 70.5534 17.5246 70.5534 20.5733C70.5514 23.6009 69.0813 25.4096 66.6214 25.4096Z" fill="#292929"></path>
                          <path d="M74.8531 12.6893H79.3368L82.9794 28.4232H78.96L74.8531 12.6893Z" fill="#292929"></path>
                          <defs><linearGradient id="paint0_linear_99_113_0.06742761728975522" x1="0" y1="19.9995" x2="100" y2="19.9995" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#3BFF9D"></stop>
                            <stop offset="1" stop-color="#3BFFC8"></stop></linearGradient>
                          </defs>
                        </svg> at checkout.
                        </div>
                      </li>
                      <li class="styles__item--28e38" style="color: rgb(84, 84, 92);">
                        <div class="styles__item-number--10e7c styles__item-number_bold--abad4" style="color: rgb(41, 41, 41);">2</div>
                        <div class="styles__item-text--5063b">Enter your information and add your debit or credit card.</div>
                      </li>
                      <li class="styles__item--28e38" style="color: rgb(84, 84, 92);">
                        <div class="styles__item-number--10e7c styles__item-number_bold--abad4" style="color: rgb(41, 41, 41);">3</div>
                        <div class="styles__item-text--5063b">Split your purchase in 4 monthly payments.</div>
                      </li>
                      <li class="styles__item--28e38" style="color: rgb(84, 84, 92);">
                        <div class="styles__item-number--10e7c styles__item-number_bold--abad4" style="color: rgb(41, 41, 41);">4</div>
                        <div class="styles__item-text--5063b">We’ll send reminders when your next payment is due.</div>
                      </li>
                    </ul>
                  </div>
                  <div class="styles__divider--c4d52" style="margin-top: 24px;"></div>
                  <div class="style__credit-card--20436" style="margin-top: 24px;">
                    <div class="style__credit-card__title--18c64">Supported payment methods</div>
                    <div class="style__credit-card__container-card--63e9c">
                      <div class="style__credit-card__master--fabba style__credit-card__item--88e09"></div>
                      <div class="style__credit-card__visa--83640 style__credit-card__item--88e09"></div>
                      <div class="style__credit-card__pay--069b9 style__credit-card__item--88e09"></div>
                    </div>
                  </div>
                </div>
              </div>
            </vuescroll>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
    import vuescroll from 'vuescroll/dist/vuescroll-native'
export default {
    components: {
        vuescroll
    },
  props: {
    title: {
      type: String,
      default() {
        return ''
      }
    },
    value: {
      type: Boolean,
      default() {
        return false
      }
    },
    total: 0
  },
  data() {
      return {
          loading: false,
      }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    formatPriceKlarna(price) {
      return Math.ceil(Number(price)/3).toLocaleString();
    },
  },
  created(){},
  mounted(){},
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.layout-info-content-window-tabby {
  position: fixed;
  z-index: 999;
  text-align: left;
  font-weight: 400;
}
.styles__body--a3828{
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  margin: auto;
  box-sizing: border-box;
  background: #fff;
  border-radius: 17px;
  color: #292929;
  font-family: "Inter", sans-serif;
  overflow: auto;
}
.styles__header--8f936{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.styles__logo--9b931 {
  height: 32px;
  width: 80px;
}
.styles__title--8f3d0 {
  display: flex;
  flex-direction: column;
}
.styles__title--8f3d0 .styles__text--bfbd9 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  font-size: 24px;
  font-style: normal;
  font-weight: bold;
  font-family: Inter, sans-serif;
}
.styles__title--8f3d0 .styles__help--4dd86 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}
.styles__body--a3828 *, .styles__body--a3828 *::before, .styles__body--a3828 *::after {
  box-sizing: inherit;
  text-transform: initial;
}
.styles__tabby-promo__graph--d0747 {
  padding: 0 18px 10px;
  display: flex;
  flex-flow: row nowrap;
  --active-ellipsis-color: #3eedbf;
  --inactive-ellipsis-color: #d1ced4;
  --dark-ellipsis-color: #54545c;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a.styles__tabby-promo__graph__ellipse_dark--a9aa7 {
  border: 1px solid var(--dark-ellipsis-color);
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid #fff;
  border-radius: 100%;
  box-sizing: border-box;
  top: 0;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a .styles__tabby-promo__graph__ellipse-section-1_dark--16948 {
  background: linear-gradient(90deg, #fff 50%, transparent 50%), linear-gradient(0deg, transparent 50%, var(--dark-ellipsis-color) 50%);
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse-divider--aeeeb {
  height: 32px;
  width: 43px;
  position: relative;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse-divider_big--770af {
  height: 40px;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse-divider--aeeeb::after {
  content: "";
  position: absolute;
  height: 1px;
  top: 50%;
  width: 100%;
  background-color: #acacb6;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse-divider_active--16b83::after {
  background-color: var(--active-ellipsis-color);
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse-divider_dark--82538::after {
  background-color: var(--dark-ellipsis-color);
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse-divider_dark--82538::after {
  background-color: var(--dark-ellipsis-color);
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a {
  display: inline-block;
  height: 32px;
  min-width: 32px;
  border-radius: 100%;
  border: 1px solid #acacb6;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-sizing: border-box;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a .styles__tabby-promo__graph__ellipse-section-1--071c6 {
  background: linear-gradient(90deg, #fff 50%, transparent 50%), linear-gradient(0deg, transparent 50%, var(--active-ellipsis-color) 50%);
  height: 100%;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a.styles__tabby-promo__graph__ellipse_big--be9f4 {
  height: 40px;
  min-width: 40px;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a.styles__tabby-promo__graph__ellipse_dark--a9aa7 {
  border: 1px solid var(--dark-ellipsis-color);
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid #fff;
  border-radius: 100%;
  box-sizing: border-box;
  top: 0;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a .styles__tabby-promo__graph__ellipse-section-2--95d79 {
  background: linear-gradient( 90deg, transparent 50%, var(--inactive-ellipsis-color) 50% );
  height: 100%;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a .styles__tabby-promo__graph__ellipse-section-2_dark--8e8eb {
  background: linear-gradient( 90deg, transparent 50%, var(--dark-ellipsis-color) 50% );
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a .styles__tabby-promo__graph__ellipse-section-3--a0593 {
  background: linear-gradient( 180deg, transparent 50%, var(--inactive-ellipsis-color) 50% ), linear-gradient( 90deg, transparent 50%, var(--inactive-ellipsis-color) 50% );
  height: 100%;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a .styles__tabby-promo__graph__ellipse-section-3_dark--3ac3f {
  background: linear-gradient( 180deg, transparent 50%, var(--dark-ellipsis-color) 50% ), linear-gradient(90deg, transparent 50%, var(--dark-ellipsis-color) 50%);
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a .styles__tabby-promo__graph__ellipse-section-4--f2562 {
  background: var(--inactive-ellipsis-color);
  height: 100%;
}
.styles__tabby-promo__graph--d0747 .styles__tabby-promo__graph__ellipse--4e44a .styles__tabby-promo__graph__ellipse-section-4_dark--b269d {
  background: var(--dark-ellipsis-color);
}
.styles__tabby-promo__graph-with-titles--8fb98 .styles__tabby-promo__graph-with-titles__descr--7eb00 .styles__tabby-promo__graph-with-titles__item-text--fe3b7 div:first-of-type {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 4px;
  color: #292929;
  font-family: Inter, sans-serif;
}
.styles__tabby-promo__graph-with-titles--8fb98 .styles__tabby-promo__graph-with-titles__descr--7eb00 .styles__tabby-promo__graph-with-titles__item-text--fe3b7 div:last-of-type {
  color: #54545c;
  font-size: 11px;
  font-family: Inter, sans-serif;
}
.styles__tabby-promo__graph-with-titles--8fb98 .styles__tabby-promo__graph-with-titles__descr--7eb00 {
  display: flex;
  flex-flow: row nowrap;
  line-height: 12px;
}
.styles__tabby-promo__graph-with-titles--8fb98 .styles__tabby-promo__graph-with-titles__descr--7eb00 .styles__tabby-promo__graph-with-titles__item-text--fe3b7 {
  display: flex;
  flex-flow: column wrap;
  text-align: center;
  margin: 0 3.5px;
  width: 68px;
  overflow: hidden;
}
.styles__tabby-promo__graph-with-titles--8fb98 .styles__tabby-promo__graph-with-titles__descr--7eb00 .styles__tabby-promo__graph-with-titles__item-text--fe3b7.styles__tabby-promo__graph-with-titles__item-text_big--b9467 {
  margin: 0 8px;
}
.styles__tabby-promo__graph-with-titles--8fb98 .styles__tabby-promo__graph-with-titles__descr--7eb00 .styles__tabby-promo__graph-with-titles__item-text--fe3b7:first-of-type {
  margin: 0 3.5px 0 0;
}
.styles__tabby-promo__graph-with-titles--8fb98 .styles__tabby-promo__graph-with-titles__descr--7eb00 .styles__tabby-promo__graph-with-titles__item-text--fe3b7.styles__tabby-promo__graph-with-titles__item-text_big--b9467:first-of-type {
  margin: 0 8px 0 0;
}
.styles__how-it-work-info--333f4 {
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}
.styles__how-it-work-info--333f4 .styles__title--c59a5 {
  font-size: 18px;
  font-style: normal;
  font-weight: bold;
}
.styles__how-it-work-info--333f4 > *:not(:first-child) {
  margin-top: 19px !important;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38 {
  font-size: 14px;
  display: flex;
  align-items: flex-start;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38::before {
  content: "";
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38 .styles__item-number--10e7c {
  font-size: 10px;
  background: #e6e5e9;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38 .styles__item-number--10e7c.styles__item-number_bold--abad4 {
  font-weight: 700;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38 > *:not(:first-child) {
  margin-left: 12px !important;
  margin-right: 0px !important;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38 .styles__item-text--5063b {
  display: inline-block;
  width: 100%;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38 .styles__item-text--5063b.styles__item-text_flex--4f618 {
  display: flex;
  align-items: center;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38 .styles__logo--0ef56 {
  margin: 0 5px;
  display: inline-block;
  width: 39px;
  height: 16px;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 .styles__item--28e38 {
  font-size: 14px;
  display: flex;
  align-items: flex-start;
}
.styles__how-it-work-info--333f4 .styles__list--21e59 > *:not(:first-child) {
  margin-top: 19px;
}

.content-header, .content-footer{
  margin: 17px 0;
}
.window {
  background: #ffffff;
  box-shadow: -170px 4px 124px rgba(0, 0, 0, 0.08);
  width: 32em;
  max-width: 100%;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 2.5em;
  display: flex;
  flex-direction: column;
  & > .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    & > .ui-button {
      margin-top: auto;
      align-self: flex-start;
      width: 190px;
    }
  }
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .close {
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      transform: rotate(90deg);
    }
  }
}

.content-wrapper {
  margin-top: 1em;
  height: 35em;
  .colors {
    display: grid;
    /*grid-template-columns: repeat(4, 1fr);*/
    grid-template-columns: repeat(auto-fit, 12em);
    grid-gap: 3em;
    .item{
      padding: 5px 20px 30px;
      &.active{
        border: 1px solid rgba(0,0,0,0.1);
        box-sizing: border-box;
      }
      .color{
        height: 7em;
      }
      label{
        display: grid;
        grid-template-columns: min-content auto;
        grid-gap: 1em;
        align-items: center;
      }
      .price{
        padding-left: 33px;
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.2s cubic-bezier(1, 0.8, 0.5, 1);
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
@media screen and (max-width: 767px) {
  .window {
    width: 100%;
    padding: 2.5em 10px;
  }
  .content-wrapper
    .colors {
      grid-gap: 1em;
  }
}
</style>
